"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.snakeCaseKeysDeep = exports.camelCaseKeysDeep = exports.changeKeysDeepWith = void 0;
var lodash_1 = require("lodash");
var defaultPredicate = function (key) { return !key.startsWith('_'); };
exports.changeKeysDeepWith = function (changeCase, predicate) {
    if (predicate === void 0) { predicate = defaultPredicate; }
    var changeKeysDeep = function (input) {
        if (!input || typeof input !== 'object') {
            return input;
        }
        if (Array.isArray(input)) {
            return input.map(changeKeysDeep);
        }
        return Object.entries(input).reduce(function (cased, _a) {
            var _b = __read(_a, 2), key = _b[0], val = _b[1];
            var maybeChangeKey = predicate(key) ? changeCase(key, val) : key;
            // @ts-ignore
            cased[maybeChangeKey] = changeKeysDeep(val);
            return cased;
        }, {});
    };
    return changeKeysDeep;
};
exports.camelCaseKeysDeep = exports.changeKeysDeepWith(lodash_1.camelCase);
exports.snakeCaseKeysDeep = exports.changeKeysDeepWith(lodash_1.snakeCase);
